import { render, staticRenderFns } from "./HistoryInfo.vue?vue&type=template&id=01751f52"
import script from "./HistoryInfo.vue?vue&type=script&lang=js"
export * from "./HistoryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports